import { render, staticRenderFns } from "./UserSoundSettings.vue?vue&type=template&id=69a70a55&scoped=true"
import script from "./UserSoundSettings.vue?vue&type=script&lang=js"
export * from "./UserSoundSettings.vue?vue&type=script&lang=js"
import style0 from "./UserSoundSettings.vue?vue&type=style&index=0&id=69a70a55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a70a55",
  null
  
)

export default component.exports